export default "__VITE_ASSET__15c3cf71__"